export enum DeliveryMode {
  Pickup = 0,
  Ship = 1,
  Arranged = 2,
}
